import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useUiStore } from '@/stores/ui.store';
import { SUPPORTED_LOCALES } from '@/lib/i18n';

/**
 * Switching the language also switches the document direction — the effect that applies
 * it lives in `providers.jsx` so `lang`/`dir` are set in exactly one place.
 */
export const LanguageToggle = () => {
  const { t } = useTranslation('common');
  const locale = useUiStore((state) => state.locale);
  const setLocale = useUiStore((state) => state.setLocale);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon-sm" aria-label={t('language.label')}>
          <Languages className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LOCALES.map(({ code, label }) => (
          <DropdownMenuItem
            key={code}
            onSelect={() => setLocale(code)}
            className={locale === code ? 'bg-accent' : undefined}
          >
            <span className="font-medium">{label}</span>
            <span className="ms-auto text-caption uppercase text-muted-foreground">{code}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageToggle;
